import { GET_BREADCRUMBS } from '@plone/volto/constants/ActionTypes';
import { flattenToAppURL, getBaseUrl } from '@plone/volto/helpers/Url/Url';

import { getBreadcrumbApiPath } from '../helpers/breadcrumbApiPath';
import { normalizeAppUrl } from '../helpers/appUrl';

/**
 * Map Plone @breadcrumbs response @id to the content path used in the app router.
 * API @id ends with /@breadcrumbs, not the page URL.
 */
export function contentPathFromBreadcrumbId(resultId) {
  if (!resultId) {
    return '';
  }
  let path = normalizeAppUrl(flattenToAppURL(resultId));
  path = path.replace(/\/@breadcrumbs\/?$/, '');
  return getBaseUrl(path);
}

/**
 * Ignore stale GET_BREADCRUMBS_SUCCESS when the response @id does not match
 * the current route (out-of-order API responses on fast navigation).
 */
export default function breadcrumbPathGuardMiddleware({ getState }) {
  return (next) => (action) => {
    if (action.type === `${GET_BREADCRUMBS}_SUCCESS`) {
      const currentPath = getBreadcrumbApiPath(
        getState().router?.location?.pathname,
      );
      const resultId = action.result?.['@id'];
      if (resultId) {
        const resultPath = contentPathFromBreadcrumbId(resultId);
        if (currentPath !== resultPath) {
          return action;
        }
      }
    }
    return next(action);
  };
}

export function installBreadcrumbPathGuard(config) {
  config.settings.storeExtenders = [
    ...(config.settings.storeExtenders || []),
    (middlewares) => [...middlewares, breadcrumbPathGuardMiddleware],
  ];
}
